const FilterCross = ({ ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.78844 8.99344L12.5709 6.21094C12.7922 5.98969 12.7922 5.63344 12.5709 5.41594C12.3497 5.19844 11.9934 5.19469 11.7759 5.41594L8.99344 8.19844L6.21094 5.41594C5.98969 5.19469 5.63344 5.19469 5.41594 5.41594C5.19844 5.63719 5.19469 5.99344 5.41594 6.21094L8.19844 8.99344L5.41594 11.7759C5.19469 11.9972 5.19469 12.3534 5.41594 12.5709C5.52469 12.6797 5.67094 12.7359 5.81344 12.7359C5.95594 12.7359 6.10219 12.6797 6.21094 12.5709L8.99344 9.78844L11.7759 12.5709C11.8847 12.6797 12.0309 12.7359 12.1734 12.7359C12.3159 12.7359 12.4622 12.6797 12.5709 12.5709C12.7922 12.3497 12.7922 11.9934 12.5709 11.7759L9.78844 8.99344Z"
      fill="#646464"
    />
  </svg>
)

export default FilterCross
